"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowContentFooter = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function WorkflowContentFooter(props) {
    var actions = props.actions;
    var next = actions.next, additional = actions.additional, back = actions.back;
    return (react_1.default.createElement(StepFooter, null,
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "space-between" },
            react_1.default.createElement("div", null, back && (react_1.default.createElement(core_ui_1.Button, { minWidth: 100, size: "secondary", type: "button", onClick: back.onClick, disabled: back.disabled, loading: back.loading }, back.text || 'Back'))),
            react_1.default.createElement(core_ui_1.Stack, { direction: "horizontal", gap: 8 },
                additional && (react_1.default.createElement(core_ui_1.Button, { type: additional.type || 'button', onClick: additional.onClick, disabled: additional.disabled, loading: additional.loading, minWidth: 136, size: "secondary" }, additional.text)),
                react_1.default.createElement(core_ui_1.Button, { type: next.type || 'submit', onClick: next.onClick, minWidth: 136, disabled: next.disabled, loading: next.loading }, next.text || 'Next')))));
}
exports.WorkflowContentFooter = WorkflowContentFooter;
function StepFooter(_a) {
    var children = _a.children;
    return (react_1.default.createElement("footer", { style: { marginTop: 40 } },
        react_1.default.createElement(core_ui_1.Divider, null),
        react_1.default.createElement(core_ui_1.Padding, { size: 40 }, children)));
}
